import React from 'react';
import './MetricCard.css';
import {
  IonCard,
  IonCardContent,
  IonCardHeader,
  IonCardSubtitle,
  IonCardTitle,
  IonIcon,
} from '@ionic/react';

type Accent = 'primary' | 'success' | 'warning' | 'danger' | 'medium';

interface MetricCardProps {
  title: string;
  value: string;
  subtitle?: string;
  context?: string;
  icon?: string;
  accent?: Accent;
}

const MetricCard: React.FC<MetricCardProps> = ({
  title,
  value,
  subtitle,
  context,
  icon,
  accent = 'primary',
}) => (
  <IonCard className={`metric-card metric-card--${accent}`}>
    <IonCardHeader>
      <div className="metric-card__header">
        <IonCardTitle>{title}</IonCardTitle>
        {icon ? <IonIcon icon={icon} size="large" /> : null}
      </div>
      {subtitle ? <IonCardSubtitle>{subtitle}</IonCardSubtitle> : null}
    </IonCardHeader>
    <IonCardContent>
      <div className="metric-card__value">{value}</div>
      {context ? <div className="metric-card__context">{context}</div> : null}
    </IonCardContent>
  </IonCard>
);

export default MetricCard;
